import React, { Component } from "react";
import L from "leaflet";
import styles from "./GeozoneListControl.module.scss";
import { withMapControl } from "../../shared/containers/containerMapControl";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Scrollbars from "react-custom-scrollbars-2";
import { withGeozones } from "../../shared/containers/geozonesContainer";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";

class GeozoneListControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  render() {
    const { isOpen } = this.state;
    const { geozoneItems, onSetMapBounds, onSelectGeozone } = this.props;
    if (geozoneItems.length === 0) return null;

    if (!isOpen) {
      return (
        <TooltipWrapper title={"Открыть список геозон"} position="right">
          <div
            className={styles.geozoneListContainerClose}
            onClick={() => {
              this.setState({ isOpen: true });
            }}
          >
            <FormatListNumberedIcon fontSize="small" />
          </div>
        </TooltipWrapper>
      );
    }

    return (
      <div className={styles.geozoneListContainerOpen}>
        <div className={styles.geozoneListControlClose}>
          <TooltipWrapper title={"Закрыть список геозон"} position="right">
            <HighlightOffIcon fontSize="small" onClick={() => this.setState({ isOpen: false })} />
          </TooltipWrapper>
        </div>

        <Scrollbars style={{ height: "200px", zIndex: 1200 }} autoHide={false} onScroll={(e) => {}}>
          {geozoneItems.map((geozone, index) => {
            return (
              <div
                key={geozone.id}
                className={styles.geozoneListItem}
                onClick={() => {
                  const geoJson = JSON.parse(geozone.geometry);

                  const latLngs = geoJson.coordinates[0].map((item) => {
                    return L.latLng(item[1], item[0]);
                  });

                  onSetMapBounds(new L.latLngBounds(latLngs));
                  onSelectGeozone(geozone);
                }}
              >
                {index + 1}. {geozone.title === null ? "Без именни" : geozone.title}
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withGeozones(withMapControl(GeozoneListControl));
